import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "hero is-primary is-fullheight" }
const _hoisted_2 = { class: "hero-body" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "columns is-centered" }
const _hoisted_5 = { class: "column is-5-tablet is-4-desktop is-4-widescreen" }
const _hoisted_6 = { class: "box has-text-centered" }
const _hoisted_7 = { class: "title is-6 has-text-grey-dark" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "block" }, " !Tu cuenta se ha registrado exitosamente! ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "block" }, " Antes de empezar, debes verificar tu cuenta con el enlace que se envio a tu correo electrónico. Si no te llego ningun correo de confirmación, presiona en el boton de abajo. ", -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h5", null, "Correo electrónico enviado", -1)
const _hoisted_13 = [
  _hoisted_12
]

import { ref } from "vue";
import { authService } from "@/services/auth";
import { useMessages } from "@/store/message";
import MessageNotificationList from "@/components/MessageNotificationList.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const msg = useMessages();
const askForNewEmail = ref(false);
const loadingButton = ref(false);
const handleNewEmail = async () => {
  loadingButton.value = !loadingButton.value;
  try {
    await authService.resendEmail();
    askForNewEmail.value = !askForNewEmail.value;
  } catch (error) {
    msg.addError("Ha ocurrido un error. Intentalo otra vez.", 4);
  } finally {
    loadingButton.value = !loadingButton.value;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h6", _hoisted_7, [
                (!askForNewEmail.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _hoisted_9,
                      _hoisted_10,
                      _createElementVNode("button", {
                        class: _normalizeClass(["button is-link is-fullwidth", [loadingButton.value ? 'is-loading' : '']]),
                        onClick: handleNewEmail
                      }, " Generar nuevo correo ", 2)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(MessageNotificationList)
  ]))
}
}

})